import React, {useCallback} from 'react';
import dayjs from 'dayjs';
import {Layout} from '../layout';
import {Text} from '../text';

type Props = {
  date: Date;
  currentDate: Date;
  currentMonth: Date;
  onSelected: (date: Date) => void;
};

export const Day: React.FC<Props> = ({
  date,
  currentDate,
  currentMonth,
  onSelected,
}) => {
  const isSelected = dayjs(date).isSame(dayjs(currentDate), 'day');
  const isDifferentMonth = !dayjs(date).isSame(dayjs(currentMonth), 'month');
  const handleSelected = useCallback(() => onSelected(date), [
    date,
    onSelected,
  ]);
  return (
    <Layout
      onPress={handleSelected}
      flex
      centered
      alignSelf="stretch"
      hover={!isSelected}
      borderRadius={isSelected ? '9999' : undefined}
      backgroundColor={
        isSelected
          ? 'background_mono_inverse_primary'
          : 'background_mono_primary'
      }>
      <Text
        variant={isSelected ? 'inline_14_emphasis' : 'inline_14_default'}
        align="center"
        textColor={
          isDifferentMonth
            ? isSelected
              ? 'content_mono_inverse_primary'
              : 'content_mono_disabled'
            : isSelected
            ? 'content_mono_inverse_primary'
            : undefined
        }>
        {date.getDate()}
      </Text>
    </Layout>
  );
};
